module.exports = __webpack_public_path__ + "img/about_pic.39f04170.png";